import { render, staticRenderFns } from "./page7.vue?vue&type=template&id=40bcc0c0&scoped=true&"
import script from "./page7.vue?vue&type=script&lang=ts&"
export * from "./page7.vue?vue&type=script&lang=ts&"
import style0 from "./page7.vue?vue&type=style&index=0&id=40bcc0c0&scoped=true&lang=css&"
import style1 from "./page7.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40bcc0c0",
  null
  
)

export default component.exports